module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-fade-in"
    }
  }, [(_vm.visible) ? _c('aside', {
    staticClass: "p-popup-backdrop"
  }, [_c('div', {
    staticClass: "p-popup-container"
  }, [_c('div', {
    staticClass: "p-popup-titlebar"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.closeButton) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d547d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/popup.vue
// module id = 35
// module chunks = 0